<xrm-notifications messageType="SystemAlert">
</xrm-notifications>
<router-outlet></router-outlet>
<xrm-notifications messageType="Toast"></xrm-notifications>